import React from 'react';
import {t} from "i18next";
import {DataTotalCalculationStatus} from "../../../../api/types";
import {api} from "../../../../api/apiProvider";
import urls from "../../../../api/urls";
import {message} from "antd";
import {CalculationStatus} from "../../../../api/constants";

interface CalculationStatusProps {
  status: DataTotalCalculationStatus,
  dataTotalId: number,
}

const getDebugData = async (id: number) => {
  return await api.fetch(`${urls.dataTotals}/${id}/debug`)
}

export default function CalculationStatusTag({status, dataTotalId}: CalculationStatusProps
) {
  const baseStyle: React.CSSProperties = {
    display: 'flex',
    padding: '4px 12px',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: 1,
    border: '0',
    alignItems: 'center',
    justifyContent: 'center',
    whiteSpace: 'nowrap',
    height: "24px"
  };

  const statusConfig = {
    [CalculationStatus.NONE]: {
      text: t('planner.calculationStatusNone'),
      style: {
        backgroundColor: '#f5f5f5',
        color: '#595959',
        borderColor: '#d9d9d9',
      }
    },
    [CalculationStatus.PENDING]: {
      text: t('planner.calculationStatusPending'),
      style: {
        backgroundColor: '#fff7e6',
        color: '#fa8c16',
        borderColor: '#ffd591',
      }
    },
    [CalculationStatus.RUNNING]: {
      text: t('planner.calculationStatusRunning'),
      style: {
        backgroundColor: '#e6f7ff',
        color: '#1890ff',
        borderColor: '#91d5ff',
      }
    },
    [CalculationStatus.SUCCESS]: {
      text: t('planner.calculationStatusSuccessful'),
      style: {
        backgroundColor: '#DBF4E3',
        color: '#044319',
        borderColor: '#b7eb8f',
      }
    },
    [CalculationStatus.FAILED]: {
      text: t('planner.calculationStatusFailed'),
      style: {
        backgroundColor: '#FFEEEB',
        color: '#420900',
        borderColor: '#ffccc7',
      }
    },
  };

  const { text, style: statusStyle } = statusConfig[status];

  const onClick = async (event: React.MouseEvent) => {
    const debugMode = event.altKey || event.ctrlKey

    if (debugMode) {
      getDebugData(dataTotalId).then((response: any) => {
        saveBody(response, dataTotalId);
      }).catch((response) => {
        message.error(response['hydra:description'])
      })
    }
  }

  const saveBody = async (response: any, id: number) => {
    try {
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      const filename = response.headers.get('content-disposition')
      ?.split('filename=')[1]
      ?.replace(/["']/g, '') || `debug_datatotal_${id}.zip`;

      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error)
    }
  };

  return (
    <span
      style={{ ...baseStyle, ...statusStyle }}
      onClick={onClick}
    >
      {text}
    </span>
  );
}
